
export class NetworkSettings {
    public readonly allowedFullScreen: boolean;
    public readonly defaultInstanceId: number;
    public readonly earnCredits: number;
    public readonly enableFeedMessages: boolean;
    public readonly enableLonelyCow: boolean;
    public readonly inviteFriends: boolean;
    public readonly maxUsernameLength: number;
    public readonly networkBuddies: boolean;
    public readonly networkName: string;
    public readonly requestPayByJS: boolean;
    public readonly showVersion: boolean;
    public readonly useExternalLinks: boolean;
    public readonly useKeyBasedLogin: boolean;
    public readonly usePayment: boolean;

    constructor(values: {
        allowedFullScreen: boolean,
        defaultInstanceId: number,
        earnCredits: number,
        enableFeedMessages: boolean,
        enableLonelyCow: boolean,
        inviteFriends: boolean,
        maxUsernameLength: number,
        networkBuddies: boolean,
        networkName: string,
        requestPayByJS: boolean,
        showVersion: boolean,
        useExternalLinks: boolean,
        useKeyBasedLogin: boolean,
        usePayment: boolean
    }) {
        this.allowedFullScreen = values.allowedFullScreen;
        this.defaultInstanceId = values.defaultInstanceId;
        this.earnCredits = values.earnCredits;
        this.enableFeedMessages = values.enableFeedMessages;
        this.enableLonelyCow = values.enableLonelyCow;
        this.inviteFriends = values.inviteFriends;
        this.maxUsernameLength = values.maxUsernameLength;
        this.networkBuddies = values.networkBuddies;
        this.networkName = values.networkName;
        this.requestPayByJS = values.requestPayByJS;
        this.showVersion = values.showVersion;
        this.useExternalLinks = values.useExternalLinks;
        this.useKeyBasedLogin = values.useKeyBasedLogin;
        this.usePayment = values.usePayment;
    }
}
